import { Reveal } from "@/components/Reveal";

const CHAPTERS = [
  {
    numeral: "I",
    title: "The death of screen clutter",
    copy: "Your television has told enough stories. It glows, it scrolls, it forgets you the moment you look away. We make evenings that ask for your hands, your voice and your full attention — and give back something a screen never can: presence.",
  },
  {
    numeral: "II",
    title: "Tangible mysteries",
    copy: "Paper that smells of cedar. Wax that yields under the thumb. A brass key with weight in the palm. Every artifact in our boxes is made to be touched, turned over and argued about long after midnight.",
  },
  {
    numeral: "III",
    title: "Theatre without walls",
    copy: "Your living room is the stage. Your friends are the cast. There is no queue, no interval, no stranger's head in front of yours — only a story that unfolds because you decided it should.",
  },
];

export const Manifesto = () => (
  <section
    id="manifesto"
    data-testid="manifesto-section"
    className="mx-auto max-w-6xl px-6 py-24 sm:px-12 sm:py-36"
  >
    <Reveal>
      <p className="font-cinzel text-[11px] tracking-[0.45em] text-gold/80">
        THE MANIFESTO
      </p>
      <h2 className="mt-6 max-w-xl font-serif text-3xl font-light text-cream sm:text-5xl">
        Three beliefs, <em className="italic text-gold">sealed in wax.</em>
      </h2>
    </Reveal>
    <div className="mt-16">
      {CHAPTERS.map((ch, i) => (
        <Reveal key={ch.numeral} delay={0.05 * i}>
          <div
            data-testid={`manifesto-chapter-${ch.numeral}`}
            className="grid grid-cols-1 gap-6 border-t border-gold/10 py-14 md:grid-cols-12 md:gap-10"
          >
            <div className="md:col-span-3">
              <span className="font-cinzel text-6xl text-gold/25 transition-colors duration-700 hover:text-gold/60 sm:text-7xl">
                {ch.numeral}.
              </span>
            </div>
            <div className="md:col-span-9">
              <h3 className="font-serif text-2xl text-cream sm:text-3xl">
                {ch.title}
              </h3>
              <p className="mt-4 max-w-2xl text-base leading-relaxed text-sand">
                {ch.copy}
              </p>
            </div>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
